export const COMMON_PATTERN = {
  IDENTITY_NUMBER_SWE: "[0-9]{8}-?[0-9]{4}",
};

export const COMMON_REGEX = {
  IDENTITY_NUMBER_SWE: /^([0-9]{8}-?[0-9]{4})$/,
};
